import { createSlice } from "@reduxjs/toolkit";

import {
    getEventsCatalogAsync,
    getSystemFieldsAsync,
    getTrackerEventsAsync,
} from "./trackerEvents.asyncActions";

const initialState = {
    trackerEvents: [],
    isLoadingTrackerEvents: false,

    eventsCatalog: [],
    filtersCatalog: [],
    isLoadingCatalog: false,

    systemFields: {},
    isLoadingSystemFields: false,
};

const trackerEventsSlice = createSlice({
    name: "trackerEvents",
    initialState,
    reducers: {
        clearTrackerEventsState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTrackerEventsAsync.pending, (state) => {
                state.isLoadingTrackerEvents = true;
            })
            .addCase(getTrackerEventsAsync.fulfilled, (state, action) => {
                state.isLoadingTrackerEvents = false;
                state.trackerEvents = action.payload || [];
            })
            .addCase(getTrackerEventsAsync.rejected, (state) => {
                state.isLoadingTrackerEvents = false;
            });

        builder
            .addCase(getEventsCatalogAsync.pending, (state) => {
                state.isLoadingCatalog = true;
            })
            .addCase(getEventsCatalogAsync.fulfilled, (state, action) => {
                state.isLoadingCatalog = false;
                state.eventsCatalog = action.payload?.events || [];
                state.filtersCatalog = action.payload?.filters || [];
            })
            .addCase(getEventsCatalogAsync.rejected, (state) => {
                state.isLoadingCatalog = false;
            });

        builder
            .addCase(getSystemFieldsAsync.pending, (state) => {
                state.isLoadingSystemFields = true;
            })
            .addCase(getSystemFieldsAsync.fulfilled, (state, action) => {
                state.isLoadingSystemFields = false;
                state.systemFields = action.payload || {};
            })
            .addCase(getSystemFieldsAsync.rejected, (state) => {
                state.isLoadingSystemFields = false;
            });
    },
});

export const { clearTrackerEventsState } = trackerEventsSlice.actions;
export default trackerEventsSlice.reducer;
